import React, { useEffect, useState } from "react";
import {Table,Row,Col,Select,Form,DatePicker,Input, Button,Typography} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { dropdownService, reportService } from "../../../services";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../utils/printing";

const { Title } = Typography;

function VendorPayableReport() {
  const [loading, setLoading] = useState(false);
  const [payables, setPayables] = useState([]);
  const [allpayables, setAllPayables] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [payload, setPayload] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [form] = Form.useForm();

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
    },
    {
      title: "Vendor",
      dataIndex: "Vendor",
      key: "Vendor",
    },
    {
      title: "Voucher Number",
      dataIndex: "Voucher Number",
      key: "Voucher Number",
    },
    {
      title: "Due Date",
      dataIndex: "Due Date",
      key: "Due Date",
    },

    {
      title: "Container Number",
      dataIndex: "Container Number",
      key: "Container Number",
    },
    {
      title: "Booking Number",
      dataIndex: "Booking Number",
      key: "Booking Number",
    },
    {
      title: "Expense Account",
      dataIndex: "Expense Account",
      key: "Expense Account",
    },
    {
      title: "Expense Sub-Account",
      dataIndex: "Expense Sub-Account",
      key: "Expense Sub-Account",
    },
    {
      title: "Total Amount",
      dataIndex: "Total Amount",
      key: "Total Amount",
    },
    {
      title: "Paid Amount",
      dataIndex: "Paid Amount",
      key: "Paid Amount",
    },
    {
      title: "Payable Amount",
      dataIndex: "Payable Amount",
      key: "Payable Amount",
    },
  ];

  const onFinish = (values) => {
    const payload = Object.fromEntries(
      Object.entries({
        ...values,
        from_date: values.from_date?.format("YYYY-MM-DD"),
        to_date: values.to_date?.format("YYYY-MM-DD"),
      }).filter(([_, value]) => value != null)
    );
    setPayload(payload);
    initialize(pagination.current, pagination.pageSize, payload);
    getAll(payload);
  };

  const initialize = async (
    page = 1,
    pageSize = pagination.pageSize,
    payload = null
  ) => {
    setLoading(true);
    const { success, data } = await reportService.VendorPayable(page, payload);
    setLoading(false);
    if (success) {
      setPayables(data);
      setPagination((prev) => ({
        ...prev,
        total: data.pagination.total,
        current: page,
        pageSize,
      }));
      // getAll();
    }
    setLoading(false);
  };

  const getVendors = async () => {
    const response = await dropdownService.fetchVendors();
    if (response.success) {
      setVendor(response.data);
    }
  };

  const getAll = async (payload) => {
    const res = await reportService.VendorPayable(1, payload, true);
    if (res.success) {
      setAllPayables(res.data.data)
    }
  }


  useEffect(() => {
    getVendors();
  }, []);


  return (
    <>
      <Title level={5}>Vendor Payable Report</Title>
      <Form
        requiredMark={false}
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Row gutter={24} className="mt-8">
          <Col span={6}>
            <Form.Item label="From date" name="from_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label="To date" name="to_date">
              <DatePicker style={{ width: "100%" }} placeholder="Select Date" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Vendors"
              name="vendorId"
              rules={[{ required: true, message: "Please input!" }]}
            >
              <Select placeholder="" showSearch optionFilterProp="children">
                {vendor.map((v) => (
                  <Select.Option key={v.id} value={v.id}>
                    {v.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item label={<></>}>
              <Button type="primary" htmlType="submit">
                <SearchOutlined style={{ fontSize: "15px" }} />
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Col span={24}>
        <Row
          gutter={0}
          style={{
            padding: "8px",
            marginTop: "2px",
            background: "#F2F2F7",
            borderRadius: "4px",
          }}
          className="flex justify-between"
        >
          <Col span={12}>
            <div className="flex">
              <Button onClick={() => handlePrint(allpayables, columns, "Vendor Payable Payments")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }} >
                <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <FaRegFile style={{ fontSize: "20px" }} />
              </Button> */}

              <Button onClick={() => exportToExcel(allpayables, "Vendor_Payable_Payments.xlsx")} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
              </Button>

              <Button onClick={() => handlePDFDownload(allpayables, columns, "Vendor Payable Payments", false)} type='primary' size='small' style={{ padding: '4px', margin: "0 5px 0 5px" }}>
                <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
              </Button>

              {/* <Button type='text' size='small' style={{ padding: '4px' }}>
                <RiFileCopyLine style={{ fontSize: "24px" }} />
              </Button> */}
            </div>
          </Col>
          <Col span={12} style={{ textAlign: "right" }}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              className="w-auto lg:w-2/5"
            />
          </Col>
        </Row>
        <div id="printable-table">
          <Table
            columns={columns}
            scroll={{ x: "max-content" }}
            pagination={{
              current: pagination.current,
              total: pagination.total,
              pageSize: pagination.pageSize,
              onChange: (page) => initialize(page, pagination.pageSize, payload),
              showSizeChanger: false,
            }}
            loading={loading}
            dataSource={payables.data}
            style={{ marginTop: "10px" }}
            summary={() => (
              <Table.Summary.Row className="font-bold bg-[#B83D3D] text-white">
                <Table.Summary.Cell
                  colSpan={columns.length - 2}
                ></Table.Summary.Cell>
                <Table.Summary.Cell>Total Payable:</Table.Summary.Cell>
                <Table.Summary.Cell>
                  ${payables?.pendingAmount}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>
      </Col>
    </>
  );
}

export default VendorPayableReport;
